// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-list-header {
  --background: var(--content-bg-color);
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/search/search/search.page.scss"],"names":[],"mappings":"AAAA;EACI,qCAAA;EACA,eAAA;AACJ","sourcesContent":["ion-list-header {\r\n    --background: var(--content-bg-color);\r\n    font-size: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
